import { cn } from "@gymflow/helpers";
import { UserMemberProfileDTOPatch } from "@gymflow/types";
import { useFormikContext } from "formik";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import {
  Button,
  CheckCircleBrokenIcon,
  ErrorMessage,
} from "../../components/atoms";
import { useClubSettings } from "../settings";

export const OnboardingFormStep4WaiverDetails = () => {
  const { t } = useTranslation();
  const { club } = useClubSettings();
  const { values, setFieldValue, errors } =
    useFormikContext<UserMemberProfileDTOPatch>();
  return (
    <motion.div
      className="flex w-full max-w-lg flex-col gap-3"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex flex-row items-center justify-between">
        <div className="dark:text-gray-0 font-semibold text-gray-950">
          {t("pages.onboarding.waiverDetails")}
        </div>
        <Button
          intent="link-secondary"
          href={club?.termsConditions ?? ""}
          target="_blank"
        >
          {t("pages.onboarding.viewWaiver")}
        </Button>
      </div>

      <div className="flex flex-col gap-2 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-950">
        <div className="flex flex-col gap-1">
          <div className="dark:text-gray-0 text-base font-semibold text-gray-950">
            {t("pages.onboarding.waiverDetailsAgree")}
          </div>
          <div className="text-sm font-medium text-gray-500">
            {t("pages.onboarding.waiverDetailsAgreeDescription")}
          </div>
        </div>

        <div className="flex flex-col gap-1.5">
          <Button
            onClick={() => {
              setFieldValue("acceptClubWaiver", true);
            }}
            className={cn("flex flex-row items-center gap-2", {
              "!text-secondary-500": values.acceptClubWaiver,
            })}
          >
            {values.acceptClubWaiver && (
              <CheckCircleBrokenIcon className="stroke-secondary-500 size-4" />
            )}
            {values.acceptClubWaiver
              ? t("pages.onboarding.accepted")
              : t("pages.onboarding.notAccepted")}
          </Button>

          {errors.acceptClubWaiver && (
            <ErrorMessage text={errors.acceptClubWaiver} />
          )}
        </div>
      </div>
    </motion.div>
  );
};
